import ManagementsUpdatePowers from "../../components/ManagementsUpdate/ManagementsUpdatePowers/ManagementsUpdatePowers";

function ManagementsUpdatePowersPage() {
  return <ManagementsUpdatePowers />;
}

export default ManagementsUpdatePowersPage;
